import { Dropdown, DropdownProps } from '@branch-messenger/willow-ui'
import { useTheme } from 'styled-components'

export const DropdownMenu = ({
  ref,
  dropdownContentProps,
  ...props
}: DropdownProps & {
  ref?: React.Ref<HTMLButtonElement>
}) => {
  const theme = useTheme()
  const { style, ...restDropdownContentProps } = dropdownContentProps || {}
  return (
    <Dropdown
      ref={ref}
      {...props}
      dropdownContentProps={{
        style: {
          padding: 0,
          borderRadius: theme.space[4],
          border: `1px solid ${theme.colors.gray}`,
          ...style,
        },
        ...restDropdownContentProps,
      }}
    />
  )
}

DropdownMenu.displayName = 'DropdownMenu'
